// extracted by mini-css-extract-plugin
export var bestFor = "t_bl";
export var ctaButton = "t_bk";
export var icons = "t_bj";
export var mainHeadRow = "t_bg";
export var secondaryHeadRow = "t_bh";
export var tableContainer = "t_bf";